module.exports = __webpack_public_path__ + "media/images/pc/special_reports/separator_white-098be413eb83d8717489160721f0dd4b.jpg";